import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-system-message',
    templateUrl: './system-message.component.html',
    styleUrls: ['./system-message.component.scss'],
    standalone: false
})
export class SystemMessageComponent implements OnInit {

  @Input() showSystemMessage: any = false;
  @Input() systemMessage: string;

  constructor() { }

  ngOnInit() {
  }

}
